export default function Management() {
  return null;
}
